/**
 * BottomNav Component
 * Kitchly v0.5.0
 *
 * 5-tab bottom nav: Inventory | Shopping | [Scan] | Family | Settings
 */
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Package,
  ShoppingCart,
  ScanBarcode,
  Users,
  Settings
} from 'lucide-react';
import './BottomNav.css';

function BottomNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <nav className="bottom-nav" role="navigation" aria-label="Main navigation">
      <NavLink to="/inventory" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <Package size={22} />
        <span>{t('nav.inventory')}</span>
      </NavLink>

      <NavLink to="/shopping" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <ShoppingCart size={22} />
        <span>{t('nav.shopping')}</span>
      </NavLink>

      <button
        className="nav-item nav-scan-btn"
        onClick={() => navigate('/scan')}
        aria-label={t('nav.scan')}
      >
        <div className="scan-btn-circle">
          <ScanBarcode size={26} />
        </div>
      </button>

      <NavLink to="/family" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <Users size={22} />
        <span>{t('nav.family')}</span>
      </NavLink>

      <NavLink to="/settings" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <Settings size={22} />
        <span>{t('nav.settings')}</span>
      </NavLink>
    </nav>
  );
}

export default BottomNav;
